var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2889 14.6765C15.1421 14.6285 14.2144 14.2103 14.7941 12.4482H14.7858C16.2969 10.8919 17.4516 8.38755 17.4516 5.92202C17.4516 2.13094 14.9307 0.143555 12.0009 0.143555C9.06916 0.143555 6.56209 2.13002 6.56209 5.92202C6.56209 8.39771 7.71039 10.9122 9.2307 12.4648C9.82332 14.0192 8.76363 14.5962 8.54209 14.6774C5.47378 15.7869 1.87378 17.8094 1.87378 19.806V20.5546C1.87378 23.2749 7.14824 23.8934 12.0295 23.8934C16.9181 23.8934 22.1261 23.2749 22.1261 20.5546V19.806C22.1261 17.7494 18.5085 15.7426 15.2889 14.6765Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro);
export default __webpack_public_path__ + "static/media/pro.2906ef1922ae901d6128c788fcdcedbc.svg";
export { ForwardRef as ReactComponent };